import React from 'react';
import { Image } from 'react-native';

import { Card, Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { ShimmerWrapper } from '@vfgroup-oneplatform/foundation/Components/Shimmer';
import { LightThemeColors, withTheme, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import Images from '../../Themes/Images';
import BillingTestKeys from '../../Utils/BillingTestKeys.js';
import VfView from '../VfView';

import styles from './HeadLine.Styles';
import { headLineLoadingConfig } from './LoadingConfigurations/HeadLineLoading.config';

function HeadLine(props) {
  const { theme } = props;

  const themedImages = getThemeImages(theme.name)

  /*   if the headline is a card it has a image place */
  const Headline = (
    <>
      <VfView
        row
        alignItems="center"
        justify="space-between"
        style={[!props.isCard && { ...styles.lineBottom(theme) }, props.style]}
      >
        <VfView row alignItems="center">
          {props.logo && (
            <Icon
              name={themedImages[props.logo]}
              size={32}
              style={[styles.logo, props.logoStyle]}
              testID={BillingTestKeys.billDetailsBreakdownHeadlineIcon}
            />
          )}

          <VfView>
            <VFText
              style={styles.title(theme)}
              i18nKey={`${props.title}`}
              testKey={BillingTestKeys.billDetailsBreakdownHeadlineTitleText}
            />
            {props.subtitle && (
              <VFText
                style={[styles.subtitle(theme), props.subtitleStyle]}
                i18nKey={`${props.subtitle}`}
                testKey={BillingTestKeys.billDetailsBreakdownHeadlineSubtitleText}
              />
            )}
          </VfView>
        </VfView>

        <VfView>
          {props.arrow && <Image style={styles.arrow} source={props.arrow} resizeMode="contain" />}
        </VfView>
      </VfView>
    </>
  );

  if (!props.isCard) {
    return Headline;
  }

  const Loader = props.loader ? (
    props.loader
  ) : (
    <ShimmerWrapper isLoading={props.isLoading} loadingConfig={headLineLoadingConfig} />
  );

  return (
    <Card style={styles.cardStyle(theme)} onPressCard={props.onPress}>
      {props.isLoading ? (
        Loader
      ) : (
        <VfView alignItems="center" justify="center">
          <VfView xs={11}>{Headline}</VfView>
        </VfView>
      )}
    </Card>
  );
}

HeadLine.defaultProps = {
  arrow: Images.chevronRightRed,
  theme: LightThemeColors,
};

HeadLine.propTypes = {
  isLoading: PropTypes.bool,
  isCard: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onPress: PropTypes.func,
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  loader: PropTypes.node,
  logo: PropTypes.object,
  arrow: PropTypes.any,
  theme: PropTypes.object,
  subtitleStyle: PropTypes.object,
  logoStyle: PropTypes.object,
};

export default withTheme(HeadLine);
